import * as cartApis from 'apis/cart';
import Vue from 'vue';

const state = {
  cartData: [], // 购物车数据
  cartDataNotEqual: false, // 本地购物车数据和服务端数据是否不一致
  totalCartInfo: {
    goods_fee: 0, // 节省金额
    goods_num: 0, // 商品数量
    total_fee: 0, // 总价
  },
};


const mutations = {
  changeCartData(state, value) {
    state.cartData = value;
  },
  changeTotalCartInfo(state, value) {
    state.totalCartInfo = value;
  },
  changeCartDataStatus(state, value) {
    state.cartDataNotEqual = value;
  },
};

const getters = {};

const actions = {
  async fetchCartData({ commit }) {
    try {
      const cartList = await cartApis.getCartData();
      if (Array.isArray(cartList)) {
        /* if (localVal && localVal.length && !cartList.length) { //  不用自动加入购物车了 2018-11-09
                  // 如果本地有购物车数据 但是接口没有返回 说明服务端session存储失效 需要自动添加到购物车
                  let cartData;
                  localVal.forEach((f) => {
                    if (f.item_id) {
                      cartData = {
                        goods_id: f.goods_id,
                        item_id: f.item_id,
                        goods_num: f.goods_num,
                      };
                    } else {
                      cartData = {
                        goods_id: f.goods_id,
                        goods_num: f.goods_num,
                      };
                    }
                    commit('changeCartDataStatus', true);
                    dispatch('fetchAddCart', cartData);
                  });
                  return;
                } */
        commit('changeCartData', cartList);
        /*  DataStore.setLocalCart(cartList); */
      }
    } catch (error) {
      // Vue.prototype.$toast(`获取数据失败:${error.message}`);
    }
  },

  async fetchAddCart({ dispatch }, conditions) {
    try {
      await cartApis.addCart(conditions);
      Vue.prototype.$toast({ message: '添加购物车成功', duration: 1000 });
      await dispatch('fetchCartData');
    } catch (error) {
      Vue.prototype.$toast({ message: `添加购物车失败:${error.message}`, duration: 1000 });
    }
  },
  subtractNum({ state: { cartData }, dispatch }, index) {
    const val = cartData[index];
    if (val.goodsNum > 1) {
      val.goodsNum -= 1;
      dispatch('fetchUpdateNum', { cart: { id: val.id, goodsNum: val.goodsNum } });
    }
  },
  addNum({ state: { cartData }, dispatch }, index) {
    const val = cartData[index];
    val.goodsNum += 1;
    dispatch('fetchUpdateNum', { cart: { id: val.id, goodsNum: val.goodsNum } });
  },
  changeStatus({ state: { cartData }, commit, dispatch }, index) {
    cartData[index].selected = Number(!cartData[index].selected);
    commit('changeCartData', cartData);
    dispatch('fetchTotalPrice');
  },
  selectAll({ state: { cartData }, dispatch }) {
    cartData.forEach((f) => {
      f.selected = 1;
    });
    dispatch('fetchTotalPrice');
  },
  selectNone({ state: { cartData, totalCartInfo }, dispatch }) {
    cartData.forEach((f) => {
      f.selected = 0;
    });
    totalCartInfo.total_fee = 0;
    dispatch('fetchTotalPrice');
  },
  // 删除购物车
  async fetchDeleteCart({ dispatch }, ids) {
    try {
      await cartApis.deleteCart({ cart_ids: ids });
      dispatch('fetchCartData');
      dispatch('fetchTotalPrice');
    } catch (error) {
      Vue.prototype.$toast(`删除购物车数据失败:${error.message}`);
    }
  },
  // 获取总价
  async fetchTotalPrice({ state: { cartData }, commit }) {
    const arr = [];
    cartData.forEach((f) => {
      arr.push({
        cartId: f.id,
        goodsNum: f.goods_num,
        selected: f.selected,
      });
    });
    try {
      const data = await cartApis.getTotalPrice({ cart: arr });
      commit('changeTotalCartInfo', data);
    } catch (error) {
      /* Vue.prototype.$toast(`${error.message}`); */
    }
  },
  // 更新数量
  async fetchUpdateNum({ dispatch }, value) {
    try {
      await cartApis.updateCartNum(value);
      dispatch('fetchTotalPrice'); // 先查价格
      dispatch('fetchCartData'); // 再更新购物车
    } catch (error) {
      Vue.prototype.$toast(`更新数量失败:${error.message}`);
      /* 更新失败也得调用下面接口  更新数据 */
      dispatch('fetchTotalPrice'); // 先查价格
      dispatch('fetchCartData'); // 再更新购物车
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
